import { AGE_OPTIONS } from '../AGE_OPTIONS';
import { AgeOptionIdType } from '../types';

const DEFAULT: AgeOptionIdType = '18-24';

export const getAgeIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): AgeOptionIdType | null => {
  const id = AGE_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
